import { SwitcherIcon, DeleteIcon } from 'foundations-assets';
import UIIconButton from 'UIComponents/button/UIIconButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEditorActions } from '../../hooks/useEditorActions';
import { useContext, useMemo, useState } from 'react';
import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { testDynamicFilterFamily } from 'customer-data-filters-ui/filterQueryFormat/DynamicFilterFamilies';
import ConditionBoxDeletePopover from '../common/ConditionBoxDeletePopover';
import { isOperator } from '../../filterQueryFormat/operator/Operator';
import { useStrategy } from '../../hooks/useStrategy';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { useViewerActions } from '../../hooks/useViewerActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getDeleteFilterButtonLabel = (condition, editorDeleteFilterButtonTooltip) => {
  if (condition && !condition.dateRefinement && !condition.numberRefinement) {
    return editorDeleteFilterButtonTooltip || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.filterGroupEditor.deleteFilter"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "newCustomerDataFilters.filterGroupEditor.deleteGroup"
  });
};
const getChangeFilterButtonLabel = (filterFamily, editorChangeFilterButtonTooltip) => {
  let token = '';
  if (testDynamicFilterFamily(DSAssetFamilies.IN_LIST, filterFamily)) {
    token = 'newCustomerDataFilters.filterGroupEditor.changeList';
  }
  if (testDynamicFilterFamily(DSAssetFamilies.IMPORT, filterFamily)) {
    token = 'newCustomerDataFilters.filterGroupEditor.changeImport';
  }
  switch (filterFamily) {
    case DSAssetFamilies.CTA:
      token = 'newCustomerDataFilters.filterGroupEditor.changeCTA';
      break;
    case DSAssetFamilies.FORM:
      token = 'newCustomerDataFilters.filterGroupEditor.changeForm';
      break;
    case DSAssetFamilies.EVENT:
      token = 'newCustomerDataFilters.filterGroupEditor.changeEvent';
      break;
    case DSAssetFamilies.EMAIL_CAMPAIGN:
      token = 'newCustomerDataFilters.filterGroupEditor.changeEmail';
      break;
    case DSAssetFamilies.WORKFLOW:
      token = 'newCustomerDataFilters.filterGroupEditor.changeWorkflow';
      break;
    default:
  }
  if (token) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: token
    });
  }
  return editorChangeFilterButtonTooltip || /*#__PURE__*/_jsx(FormattedMessage, {
    message: 'newCustomerDataFilters.filterGroupEditor.changeFilterType'
  });
};
const EditorConditionActions = props => {
  const {
    onConditionDelete,
    filterFamily,
    conditionPath,
    condition,
    hideChangeFieldButton = false,
    isFilterBranch
  } = props;
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const {
    props: {
      uiMessages: {
        editorChangeFilterButtonTooltip,
        editorDeleteFilterButtonTooltip
      },
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getRequiredFields
  } = useStrategy();
  const {
    changeField
  } = useEditorActions();
  const {
    onConditionDeleteCancel,
    onConditionDeleteConfirm,
    onConditionDeleteHover,
    onConditionDeleteTrigger
  } = useViewerActions();
  const canChangeField = filterFamily && conditionPath;
  const onDeleteButtonClick = () => {
    if (isFilterBranch) {
      setIsPopoverOpen(true);
      if (useOnePanel && conditionPath) {
        onConditionDeleteTrigger(conditionPath);
      }
    } else {
      onConditionDelete();
    }
  };
  const onDeleteButtonMouseEnter = () => {
    if (useOnePanel) {
      onConditionDeleteHover(conditionPath);
    }
  };
  const onDeleteButtonMouseLeave = () => {
    if (useOnePanel) {
      onConditionDeleteHover(undefined);
    }
  };
  const onConditionDeleteCancelHandler = () => {
    setIsPopoverOpen(false);
    if (useOnePanel) {
      onConditionDeleteCancel();
    }
  };
  const onConditionDeleteConfirmHandler = () => {
    onConditionDelete();
    if (useOnePanel && conditionPath) {
      onConditionDeleteConfirm(conditionPath);
    }
  };
  const disabledActionButtonTooltip = useMemo(() => {
    if (filterFamily && isOperator(condition)) {
      const requiredFields = getRequiredFields(filterFamily);
      if (condition.field && requiredFields.has(condition.field.name)) return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.requiredFieldDisabledButtonTooltip"
      });
    }
    return undefined;
  }, [filterFamily, condition, getRequiredFields]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [canChangeField && !hideChangeFieldButton && /*#__PURE__*/_jsx(UIIconButton, {
      "data-selenium-test": "fr-change-filter-btn",
      "data-test-id": "change_filter",
      disabled:
      // @ts-expect-error FIXME: incomplete condition types
      condition.field.userHasNoAccess || Boolean(disabledActionButtonTooltip),
      onClick: () => changeField(filterFamily, conditionPath),
      size: "small",
      use: "transparent",
      tooltipProps: {
        title: disabledActionButtonTooltip || getChangeFilterButtonLabel(filterFamily, editorChangeFilterButtonTooltip)
      },
      children: /*#__PURE__*/_jsx(SwitcherIcon, {})
    }), /*#__PURE__*/_jsx(ConditionBoxDeletePopover, {
      isOpen: isPopoverOpen,
      onCancel: onConditionDeleteCancelHandler,
      onConfirm: onConditionDeleteConfirmHandler,
      children: /*#__PURE__*/_jsx(UIIconButton, {
        disabled: Boolean(disabledActionButtonTooltip),
        className: "m-left-1",
        "data-selenium-test": "fr-delete-filter-btn",
        "data-test-id": "delete_filter",
        name: "delete",
        onClick: onDeleteButtonClick,
        onMouseEnter: onDeleteButtonMouseEnter,
        onMouseLeave: onDeleteButtonMouseLeave,
        size: "small",
        use: "transparent",
        tooltip: disabledActionButtonTooltip || condition && getDeleteFilterButtonLabel(condition, editorDeleteFilterButtonTooltip),
        children: /*#__PURE__*/_jsx(DeleteIcon, {})
      })
    })]
  });
};
export default EditorConditionActions;